
class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', ()=>{
      this.openDrawerViaEventHandler;
      this.cartcountupdate();
      // this.loadCartData();
    });
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', ()=>{
      this.cartcountupdate();
      this.cartRefreshHandler();
      // this.loadCartData();
    });
    this.addEventListener('on:cart-drawer:before-open', () => {
      this.cartcountupdate();
      theme.manuallyLoadImages(this);
      // this.loadCartData();
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      this.cartcountupdate();
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    console.log('reloading');
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }

 loadCartData() {
    console.log('Fetching cart data from cart.js');
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((cartData) => {
        console.log('Cart data loaded successfully:', cartData);

        // If the cart is empty, do nothing
        if (cartData.items.length === 0) {
          console.log('Cart is empty. No action needed.');
          return;
        }

        // Check if the cart contains only the "gift" item (ID 52077861634417)
        const isSingleGiftItemInCart = cartData.items.length === 1 && cartData.items[0].id === 52077861634417;
        
        if (isSingleGiftItemInCart) {
          console.log('Cart contains only the gift item. Clearing cart...');
          
          // Clear the cart by calling the clear.js endpoint
          fetch('/cart/clear.js', { method: 'POST' })
            .then((clearResponse) => {
              if (!clearResponse.ok) {
                throw new Error(`HTTP error! Status: ${clearResponse.status}`);
              }
              return clearResponse.json();
            })
            .then((clearData) => {
              console.log('Cart cleared:', clearData);
              // Optionally, refresh the cart UI or notify the user
            })
            .catch((error) => {
              console.error('Error clearing cart:', error);
            });
        } else {
          // If the cart does not have the "gift" item, add it
          const hasGiftItem = cartData.items.some(item => item.id === 52077861634417);

          if (!hasGiftItem) {
            console.log('Gift item not found in cart. Adding it...');
            
            // Add the "gift" item to the cart (ID 52077861634417)
            this.addItemToCart(52077861634417, 1); // Example: Adding 1 quantity
          } else {
            console.log('Gift item already in the cart');
          }
        }

        // Perform refresh twice as required
        this.cartRefreshHandler(); // First refresh
        setTimeout(() => {
          this.cartRefreshHandler(); // Second refresh after a small delay
        }, 300); // Delay between two refreshes (you can adjust the delay as needed)
      })
      .catch((error) => {
        console.error('Error fetching cart data:', error);
      });
}

  cartcountupdate() {
    console.log('Fetching cart data to update item count...');
    
    // Fetch cart data from /cart.js
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((cartData) => {
        console.log('Cart data loaded:', cartData);
  
        // Get the cart item count
        const itemCount = cartData.items.reduce((total, item) => total + item.quantity, 0);
  
        // Find the cart count span and update it
        const cartCountElement = document.querySelector('.cart-link__count');
        if (cartCountElement) {
          cartCountElement.textContent = itemCount; // Update the count
          console.log('Cart count updated to:', itemCount);
        } else {
          console.error('Cart count element not found');
        }
      })
      .catch((error) => {
        console.error('Error fetching cart data:', error);
      });
  }


  /**
   * Add an item to the cart via /cart/add.js
   * @param {number} variantId - The variant ID of the product.
   * @param {number} quantity - The quantity of the product to add.
   */
  addItemToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Item added to cart:', data);
        // Refresh the cart after adding the item
        this.cartRefreshHandler();
      })
      .catch((error) => {
        console.error('Error adding item to cart:', error);
      });
  }
}

window.customElements.define('cart-drawer', CartDrawer);
